module.exports = __webpack_public_path__ + "static/Ranger 5-d70347497a7b3db506ae06203a688f42.jpg";